import axios from 'axios';
import { smallNotification } from '@shared/services/gf.notification.service';
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member
import HelperS from '../../services/helper.service';
import store from '../../../store';

export default {
  getVulnerabilities(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/vulnerability-occurrence`, {
        params: { ...HelperS.getRealPagination(params || {}) }
      })
      .then((res) => {
        store.dispatch('setVulnerability', { vulnerabilityTool: params?.vulnerabilityTool || '', vulnerability: HelperS.parsePagination(res.data) });
        return HelperS.parsePagination(res.data);
      });
  },
  getVulnerability(userAlias, projectAlias, id) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/vulnerability-occurrence/${id}`)
      .then(
        (res) =>
          // store.dispatch('setPipelines', HelperS.parsePagination(res.data));
          res.data
      );
  },
  getVulnerabilitiesByPipeline(userAlias, projectAlias, id, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/security/occurrence-pipeline/${id}`, {
        params: { ...HelperS.getRealPagination(params || {}) }
      })
      .then((res) => {
        store.dispatch('setVulnerabilitiesByPipeline', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      });
  },
  getVulnerabilitiesByMerge(userAlias, projectAlias, id, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/security/occurrence-pipeline/merge-request/${id}`, {
        params: { ...HelperS.getRealPagination(params || {}) }
      })
      .then((res) => res.data);
  },
  getVulnerabilityCounter(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/vulnerability-statistic`, {params})
      .then((res) => res.data);
  },
  getVulnerabilityFile(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/blob`, {
        params
      })
      .then((res) => res.data);
  },
  setVulnerabilityStatus(userAlias, projectAlias, id, data, params) {
    return axios
      .post(
        `/api/project/${userAlias}/${projectAlias}/vulnerability-occurrence/status-change/${id}`,
        data,
        params
      )
      .then(() => {
        smallNotification('success', { title: 'Статус изменен!' });
      });
  },
  setMultiplyVulnerabilityStatus(userAlias, projectAlias, data) {
    return axios
      .post(
        `/api/project/${userAlias}/${projectAlias}/vulnerability-occurrence/multiple-status-change`,
        data
      )
      .then(() => {
        smallNotification('success', { title: 'Статус изменен!' });
      });
  }
};
